module.exports = new __parcel__URL__("whale01.170b4c81.png").toString();